import { FC } from 'react'
import { ReactNode } from 'react-redux'
import styles from 'components/features/videoCallPanel/CallPanelPreset/CallPanelPreset.styl'
import cn from 'classnames'
import { cssVar } from 'helpers/styleHelpers'
import { DEFAULT_ASPECT_RATIO } from 'components/features/videoCalls/constants'

type CallPanelPresetProps = {
  isFullScreen: boolean
  mainFrame: ReactNode
  participants: ReactNode[]
  aspectRatio?: number
}
export const CallPanelPreset: FC<CallPanelPresetProps> = (props) => {
  const { mainFrame, participants, isFullScreen, aspectRatio = DEFAULT_ASPECT_RATIO } = props
  return (
    <div
      className={ cn(styles.callPanelPreset, isFullScreen && styles.fullScreen, !participants.length && styles.noParticipants) }
      style={ cssVar({
        '--aspectRatio': aspectRatio,
      }) }
    >
      <div className={ styles.mainFrame }>
        { mainFrame }
      </div>
      { !!participants.length && (
        <div className={ styles.participants }>
          <div className={ styles.participantsPlaceholder }>
            <div className={ styles.participantsWrapper }>
              { participants }
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
